// Radix adds this variable to body when it removes scroll bar
export const CSS_VARIABLE_REMOVED_SCROLL_BAR = '--removed-body-scroll-bar-size';
